module.exports = __webpack_public_path__ + "media/images/app_buttons/button__googlePlay--fr-794aa1935ca06bb4b5a58d9d0e715b86.svg";